import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AccessLevel, CustomFeatureClient, useUserData } from '../../shared/hooks/useUserData';

export function SupportSection() {
  const { userData } = useUserData();
  const { eapPhoneNumber, emergencyPhoneNumber, access } = userData;
  const { t } = useTranslation();

  const panelAvailable = [
    AccessLevel.Admin,
    AccessLevel.ParentClientAdmin,
    AccessLevel.ChildClientAdmin,
  ].includes(access);

  const supportLink = useMemo(() => {
    if (userData?.customFeatureClient === CustomFeatureClient.PAM) {
      return '/support/services';
    }
    return '/support';
  }, [userData?.customFeatureClient]);

  return (
    <div id="section_progress">
      <div id="assessment_support_footer">
        <h2 className="title">{t('AS001_need_support')}</h2>
        <div className="items">
          {panelAvailable && userData?.customFeatureClient === CustomFeatureClient.PAM && (
            <a className="item" href="/panel">
              {t('AS005_go_to_panel')}
            </a>
          )}
          {!panelAvailable &&
            eapPhoneNumber &&
            userData?.customFeatureClient === CustomFeatureClient.PAM && (
              <a className="item" href={`tel:${eapPhoneNumber}`}>
                {`${t('AS002_eap_helpline')} ${eapPhoneNumber}`}
              </a>
            )}
          {emergencyPhoneNumber && (
            <a className="item" href={`tel:${emergencyPhoneNumber}`}>
              {`${t('AS003_crisis_helpline')} ${emergencyPhoneNumber}`}
            </a>
          )}
          <Link className="item" to={supportLink}>
            {t('AS004_support_resources')}
          </Link>
        </div>
      </div>
    </div>
  );
}
